export const CONTACT_TYPE_DISPLAY_NAMES = {
    Signatory: "Authorised Signatory",
    "Human Resources": "HR",
};

export const buildContactTypeLabels = (contactTypes) => {
    if (!Array.isArray(contactTypes)) return {};

    return contactTypes.reduce((labels, contactType) => {
        labels[contactType.id] =
            CONTACT_TYPE_DISPLAY_NAMES[contactType.name] ?? contactType.name;
        return labels;
    }, {});
};

export const getContactTypeTags = (contact, labels) => {
    const primaryTypes = contact?.primaryTypes || [];
    const secondaryTypes = contact?.types || [];
    const primaryTypeIds = (
        Array.isArray(primaryTypes) ? primaryTypes : []
    ).map(String);
    const secondaryTypeIds = (
        Array.isArray(secondaryTypes) ? secondaryTypes : []
    ).map(String);
    const typeIds = [...new Set([...primaryTypeIds, ...secondaryTypeIds])];

    return typeIds.map((typeId) => {
        const isPrimary = primaryTypeIds.includes(typeId);
        const label = labels?.[typeId] ?? `Type ${typeId}`;

        return {
            typeId,
            isPrimary,
            label: `${isPrimary ? "Primary" : "Secondary"} ${label}`,
        };
    });
};
